import { useMutation, useQueryClient } from 'react-query';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import {
  PhysicalExaminationType,
  requestGenerateSkinExaminationVideo,
} from '@higo/api';
import { useDispatchDoctorTrackedType } from 'hooks/useDispatchDoctorTrackedEvent';
import { DoctorTrackedType } from '@higo/common/lib/features/TrackedEvent';

export const useRequestGenerateSkinExaminationVideoMutation = () => {
  const { authorizedAxios } = useDoctorPortalApiContext();
  const queryClient = useQueryClient();
  const sendTrackedEvent = useDispatchDoctorTrackedType();

  return useMutation(requestGenerateSkinExaminationVideo(authorizedAxios), {
    onSuccess: (_, variables) => {
      sendTrackedEvent({
        event: DoctorTrackedType.RequestVisualExaminationVideo,
        eventResult: 'success',
        physicalExaminationType: PhysicalExaminationType.Skin,
        examinationId: variables,
      });
    },

    onError: (error, variables, context) => {
      sendTrackedEvent({
        event: DoctorTrackedType.RequestVisualExaminationVideo,
        eventResult: 'error',
        physicalExaminationType: PhysicalExaminationType.Skin,
        examinationId: variables,
      });

      // call global error handler
      return queryClient
        .getDefaultOptions()
        ?.mutations?.onError?.(error, variables, context);
    },
  });
};
